import { Dispatch } from 'redux'
import axios from '../../../config/axios'
import { setEventDetailsReport, setEventDetailsReportLoading, setEventDetailsReportError } from './slice'

export const fetchEventDetailsReport = () => async (dispatch: Dispatch) => {
  try {
    dispatch(setEventDetailsReportLoading(true))
    dispatch(setEventDetailsReportError(null))

    const response = await axios.get('/report/event/details')

    dispatch(setEventDetailsReport(response.data))
  } catch (error) {
    console.error('Error fetching event details report:', error)
    dispatch(
      setEventDetailsReportError(
        error instanceof Error
          ? error.message
          : 'An unknown error occurred while fetching event details report',
      ),
    )
  } finally {
    dispatch(setEventDetailsReportLoading(false))
  }
}
